import useFetchMultiplePayments from '../../../core/apiHooks/useFetchMultiplePayments';
import { selectModelCardPreferredPaymentOptions, selectDefaultPaymentOptions, selectPrimaryCalculatorPaymentMethod, PAYMENT_OPTIONS_OVERRIDES, } from '../../../core/reducers/financialCalculators';
import { useAppSelector } from '../../../core/utils';
export const useModelCardsWithPaymentData = (modelCards, shouldFetch) => {
    var _a;
    const paymentRequests = modelCards.map(modelCard => ({
        modelKey: modelCard.modelKey,
        modelYear: modelCard.year,
        trimKey: modelCard.trimKey,
        transmissionKey: modelCard.defaultTransmission,
        exteriorColorKey: modelCard.exteriorColorKey,
        interiorColorKey: modelCard.interiorColorKey,
        accessories: [],
        protections: [],
        protectionAddOns: [],
    }));
    // payments that reflect the user's selected payment options
    const singleModelCardPreferredPaymentOptions = useAppSelector(selectModelCardPreferredPaymentOptions);
    const paymentMethod = useAppSelector(selectPrimaryCalculatorPaymentMethod);
    const modelCardPreferredPaymentOptions = modelCards.map(modelCard => {
        const preferredPaymentMethod = modelCard.availablePaymentMethods.includes(paymentMethod)
            ? paymentMethod
            : modelCard.availablePaymentMethods[0];
        return {
            ...singleModelCardPreferredPaymentOptions,
            warrantyAmount: 0,
            incentiveOfferIds: PAYMENT_OPTIONS_OVERRIDES.incentiveOfferIds,
            paymentMethod: preferredPaymentMethod,
        };
    });
    const selectedPayments = useFetchMultiplePayments(paymentRequests, shouldFetch ? modelCards.length > 0 : false, modelCardPreferredPaymentOptions);
    const hasSelectedPaymentsData = selectedPayments.isSuccess && !!selectedPayments.data;
    // payments that reflect the default payment options
    const singleDefaultPaymentOptions = useAppSelector(selectDefaultPaymentOptions);
    singleDefaultPaymentOptions.warrantyAmount = 0;
    const defaultPaymentOptions = Array.from({ length: modelCards.length }, () => ({
        ...singleDefaultPaymentOptions,
        incentiveOfferIds: PAYMENT_OPTIONS_OVERRIDES.incentiveOfferIds,
    }));
    const defaultPayments = useFetchMultiplePayments(paymentRequests, shouldFetch ? modelCards.length > 0 && hasSelectedPaymentsData : false, defaultPaymentOptions);
    const hasDefaultPaymentsData = defaultPayments.isSuccess && !!defaultPayments.data;
    const payments = hasSelectedPaymentsData
        ? (_a = selectedPayments.data) === null || _a === void 0 ? void 0 : _a.map((selectedPayment, i) => {
            var _a;
            // If the payment is falsy (null/undefined; a payment API error),
            // return the corresponding element from the default payments
            if (!selectedPayment && hasDefaultPaymentsData) {
                return (_a = defaultPayments.data) === null || _a === void 0 ? void 0 : _a.find((p) => {
                    var _a, _b, _c, _d, _e, _f;
                    return !!p &&
                        p.detKeys.modelKey === ((_a = modelCards[i]) === null || _a === void 0 ? void 0 : _a.modelKey) &&
                        p.detKeys.trimKey === ((_b = modelCards[i]) === null || _b === void 0 ? void 0 : _b.trimKey) &&
                        p.detKeys.modelYear === ((_c = modelCards[i]) === null || _c === void 0 ? void 0 : _c.year) &&
                        p.detKeys.transmissionKey === ((_d = modelCards[i]) === null || _d === void 0 ? void 0 : _d.defaultTransmission) &&
                        p.detKeys.exteriorColorKey === ((_e = modelCards[i]) === null || _e === void 0 ? void 0 : _e.exteriorColorKey) &&
                        p.detKeys.interiorColorKey === ((_f = modelCards[i]) === null || _f === void 0 ? void 0 : _f.interiorColorKey);
                });
            }
            return selectedPayment;
        })
        : defaultPayments.data;
    const isFetching = selectedPayments.isFetching || defaultPayments.isFetching;
    const isLoading = selectedPayments.isLoading || defaultPayments.isLoading;
    const modelCardsWithPaymentData = modelCards.map(modelCard => {
        const payment = payments === null || payments === void 0 ? void 0 : payments.find(p => !!p &&
            p.detKeys.modelKey === modelCard.modelKey &&
            p.detKeys.trimKey === modelCard.trimKey &&
            p.detKeys.modelYear === modelCard.year &&
            p.detKeys.transmissionKey === modelCard.defaultTransmission &&
            p.detKeys.exteriorColorKey === modelCard.exteriorColorKey &&
            p.detKeys.interiorColorKey === modelCard.interiorColorKey);
        if (hasSelectedPaymentsData && hasDefaultPaymentsData && !payment)
            return {
                ...modelCard,
                paymentData: {
                    data: undefined,
                    error: { message: 'No payment' },
                    isFetching: false,
                    isLoading: false,
                },
            };
        return {
            ...modelCard,
            paymentData: { data: payment, error: undefined, isFetching, isLoading },
        };
    });
    return modelCardsWithPaymentData;
};
export default useModelCardsWithPaymentData;
